import Mousetrap from 'mousetrap';
import { useEffect } from 'react';

/* View in fullscreen */
function openFullscreen() {
  document.documentElement?.requestFullscreen?.();
}

export default function initMousetraps() {
  // Mousetrap's built-in stopCallback has a `_belongsTo` check that
  // short-circuits when bound to `document`, so the INPUT/TEXTAREA guard
  // is never reached. Override to fix this.
  Mousetrap.prototype.stopCallback = function (_e: KeyboardEvent, element: Element) {
    const tagName = element.tagName;
    return (
      tagName === 'INPUT' ||
      tagName === 'SELECT' ||
      tagName === 'TEXTAREA' ||
      (element as HTMLElement).isContentEditable
    );
  };

  Mousetrap.bind('shift+f', openFullscreen);
}

export const useMousetrap = () => {
  useEffect(() => {
    initMousetraps();
  }, []);
};
